module.exports = __webpack_public_path__ + "static/oskrds-5c55d1d0c24319a2fa641ed8b2becc94.webm";